import ButtonT from '@components/tailwind-components/Button/ButtonT';
import ColorInputWithLabelT from '@components/tailwind-components/Input/ColorInputWithLabelT';
import InputWithLabelT from '@components/tailwind-components/Input/InputWithLabelT';
import type React from 'react';
import { useForm } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { useModal } from '../../../../hooks/modal/useModal';
import type { TLabelUpdateable } from '../../../../interfaces/TChat';

type Props = {
  data?: Partial<TLabelFormData>;
  onSubmit: (data: TLabelFormData) => void;
};

type TLabelFormData = TLabelUpdateable;

export const LabelDataModal: React.FC<Props> = ({ data, onSubmit }) => {
  const { t } = useTranslation();

  const { handleSubmit, control, getValues } = useForm<TLabelFormData>({
    shouldUseNativeValidation: true,
    defaultValues: {
      labelName: data?.labelName,
      labelColor: data?.labelColor,
    },
  });

  const { hideModal } = useModal();

  const hideAndSubmit = (data: TLabelFormData) => {
    onSubmit({
      labelName: data.labelName,
      labelColor: data.labelColor,
    });
    hideModal();
  };

  return (
    <form
      className='tailwind-modal-form'
      onSubmit={handleSubmit(hideAndSubmit)}>
      <div className='tailwind-modal-body'>
        <div className='grid grid-cols-1 gap-x-6 gap-y-2'>
          <div className='col-span-1'>
            <InputWithLabelT
              type='text'
              field='labelName'
              placeholder={t('settings.label.name')}
              label={t('settings.label.name')}
              id='labelName'
              control={control}
              options={{
                required: t('settings.label.validation.name'),
              }}
            />
          </div>
          <div className='col-span-1'>
            <ColorInputWithLabelT
              field='labelColor'
              defaultValue={getValues('labelColor')}
              label={t('settings.label.color')}
              id='labelColor'
              control={control}
              options={{
                required: t('settings.label.validation.color'),
              }}
            />
          </div>
        </div>
      </div>
      <div className='tailwind-modal-footer'>
        <ButtonT
          type='button'
          styling='cancel'
          size='xs'
          rounding='md'
          onClick={hideModal}>
          {t('general.buttons.cancel')}
        </ButtonT>
        <ButtonT type='submit' styling='primary' size='xs' rounding='md'>
          {t('general.buttons.save')}
        </ButtonT>
      </div>
    </form>
  );
};

export default LabelDataModal;
